angular.module('skeyenoteWebApp').directive('ngEscape', NgEscapeDirective);

function NgEscapeDirective() {
  return function(scope, element, attrs) {
    element.bind('keydown keyup', function(event) {
      if (event.which === 27) {
        scope.$apply(function() {
          scope.$eval(attrs.ngEscape);
        });
        event.preventDefault();
      }
    });
  };
}
